export default {"src":"/_next/static/media/TAG1.cf8073bf.svg","height":200,"width":200,"blurWidth":0,"blurHeight":0};